<style scoped>

* {
    border: 0px black solid;
    background-color: #fff5f5;

}



a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.title_story {
  font-size: 80px;
  font-family: 'Work Sans', sans-serif;
  padding-left: 20px;
  padding-top: 70px;
  color: #333042
}

.container_width {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 70px;

}

.leek_scans {
  max-width: 100%;
  padding-bottom: 40px;
  padding-top: 40px;

}

.author {
  font-size: 20px;
  font-family: 'Poppins', sans-serif;;
  padding-left: 20px;


}

.small_icon {
  max-width: 20%;
  padding-top: 70px;
}


   @media (max-width: 575px){
        .small_icon {
          max-width: 50%;
          padding-top: 20px;

        }
        .title_story {
          font-size: 30px;
        }
        .author {
          font-size: 15px;
        }
      }
</style>

<template>
  <b-container fluid class="p-0">
    <MenuBar/>
    <b-row>
      <b-col md="8">
        <p class="title_story">Leek pilaf</p>
        <b-row>
          <b-col md="6">
            <p class="author">a recipe by Artemis</p>

          </b-col>
        </b-row>
      </b-col>
      <b-col md="2" class="small_icon">

        <a href="/onion"><b-img center class="img-fluid" alt="Responsive image" src="media/onion_prev.png"> </b-img></a>
      </b-col>
      <b-col md="2" class="small_icon">

        <a href="/ricecooker"><b-img center class="img-fluid" alt="Responsive image" src="media/rice_next.png"> </b-img></a>
      </b-col>

    </b-row>


    <b-row>

      <b-col class="leek_scans" md="4" offset-md="2">
                <b-img class="img-fluid" center src="media/leek/leek-pilaf-1.JPG"></b-img>

      </b-col>

      <b-col class="leek_scans" md="4" >
        <b-img class="img-fluid" center src="media/leek/leek-pilaf-2.JPG"></b-img>

      </b-col>

    </b-row>

    <b-row>
      <b-col md="12">
        <p></p>

      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <p></p>

      </b-col>
    </b-row>


  </b-container>

</template>

<script>
import MenuBar from '../MenuBar'
export default {
    name: 'leekpilaf',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
